export interface User {
	_id: string;
	name: string;
	nick_name: string;
	user: string;
	phone_number: string;
	role: string;
	jwt_token: string;
	color: string;
	isDeveloper: boolean;
}

export enum InputType {
	email = "email",
	phone = "phone",
}
